import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12.462 20.879h9.462M3 20.879h1.76c.515 0 .772 0 1.014-.058.214-.052.42-.137.608-.252.212-.13.394-.312.757-.676L20.347 6.686a2.23 2.23 0 1 0-3.154-3.154L3.985 16.739c-.363.364-.545.546-.675.758q-.173.284-.252.608C3 18.347 3 18.604 3 19.118z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }